import script from "./AdminListingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminListingDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdminListingDetails.vue?vue&type=style&index=0&id=e6045df0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6045df0"]])

export default __exports__